import React from 'react';
import { Helmet } from 'react-helmet';
import { Switch, Route, Redirect } from 'react-router-dom';

// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';

import Spray from './scenes/Spray';
import Varieties from './scenes/Varieties';
import Commodities from './scenes/Commodities';

const { REACT_APP_PROJECT_NAME } = process.env;

const Settings = (): React.ReactElement => (
    <ErrorBoundary
        namespace="Settings"
        FallbackComponent={<ErrorBoundaryAlert />}
    >
        <Helmet>
            <title>Settings - {REACT_APP_PROJECT_NAME}</title>
        </Helmet>
        <Switch>
            <Redirect exact from="/organization/settings" to="/organization" />
            <Route
                exact
                path="/organization/settings/spray"
                component={Spray}
            />
            <Route
                exact
                path="/organization/settings/varieties"
                component={Varieties}
            />
            <Route
                exact
                path="/organization/settings/commodities"
                component={Commodities}
            />
            <Redirect from="/organization/settings/*" to="/organization" />
        </Switch>
    </ErrorBoundary>
);

export default Settings;
